module.exports = __webpack_public_path__ + "img/trash.ccaa9ea1.svg";